import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ApproveCashAppPayRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ApproveCashAppPayResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const approveCashAppPay = (request: ApproveCashAppPayRequest, options?: CashRequestOptions) =>
  post<ApproveCashAppPayRequest, ApproveCashAppPayResponse>('/2.0/cash/approve-cash-app-pay', request, {
    ...options,
    rejectOnError: true,
  })
